import { NgModule } from '@angular/core';
import { ClientLoginRoutingModule } from './clientLogin-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginModule } from 'src/app/shared/module/login/login.module';
import { ClientLoginComponent } from './components/clientLogin/clientLogin.component';
import { CustomLabelService } from 'src/app/shared/service/customLabel.service';
import { LoginCardComponent } from './components/login-card/login-card.component';
import { CardModelComponent } from './components/card-model/card-model.component';

@NgModule({
  declarations: [ClientLoginComponent, LoginCardComponent, CardModelComponent],
  imports: [
    ClientLoginRoutingModule,
    DropDownsModule,
    CommonModule,
    LoginModule,
    FormsModule,
    TranslateModule,
  ],
  providers: [CustomLabelService],
})
export class ClientLoginModule {}
